import { Link } from 'react-router';
import { ChevronRightIcon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';
import { formatMoney } from '@/lib/utils';
import type { PayrollOwedDto } from '@/lib/api/payroll';

interface Props {
  owed: PayrollOwedDto;
  to: string;
}

export function PayrollOwedRow({ owed, to }: Props) {
  const { t } = useLanguage();

  return (
    <Link
      to={to}
      className="flex items-center justify-between gap-3 px-4 py-3 rounded-xl border bg-card hover:shadow-sm transition-shadow"
      data-testid={`payroll-owed-row-${owed.employee_id}`}
    >
      <div className="min-w-0">
        <p className="font-semibold text-sm truncate">{owed.full_name}</p>
        <p className="text-xs text-muted-foreground truncate">{owed.email}</p>
      </div>
      <div className="flex items-center gap-5 shrink-0">
        <div className="text-right">
          <p className="text-[11px] text-muted-foreground">{t.payrollVisitsOwed}</p>
          <p className="text-sm font-medium">{owed.visits_owed}</p>
        </div>
        <div className="text-right">
          <p className="text-[11px] text-muted-foreground">{t.payrollTotalOwed}</p>
          <p className="text-sm font-semibold">{formatMoney(owed.total_owed)}</p>
        </div>
        <ChevronRightIcon className="w-4 h-4 text-muted-foreground shrink-0" />
      </div>
    </Link>
  );
}
